import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import TitleWithBack from '../../components/common/TitleWithBack';

function UsersEdit() {
  const { userId } = useParams();
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    fullName: '',
    username: '',
    email: '',
    contactNo: '',
    password: '',
    address: '',
    role: '',
    userCategory: '',
    enabled: true,
  });
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [tooltip, setTooltip] = useState('');

  const roleIdMapping = { admin: 1, archiver: 2, examiner: 3, 'data team': 4, security: 5 };

  useEffect(() => {
    axios.get('/api/user-categories?page=0&size=10&sortBy=id')
      .then(response => {
        const cats = response.data.content || response.data;
        setCategories(cats);
      })
      .catch(err => console.error('Error fetching categories', err));
  }, []);

  useEffect(() => {
    axios.get(`/api/users/${userId}`)
      .then(response => {
        const user = response.data;
        let singleRoleName = '';
        if (user.roles && user.roles.length > 0) {
          singleRoleName = user.roles[0].name;
        }
        setUserData({
          fullName: user.fullName || '',
          username: user.username || '',
          email: user.email || '',
          password: '',
          contactNo: user.contactNo || '',
          address: user.address || '',
          role: singleRoleName,
          userCategory: user.userCategory ? user.userCategory.id : '',
          enabled: typeof user.enabled === 'boolean' ? user.enabled : true,
        });
        setLoading(false);
      })
      .catch(err => {
        setError('Error fetching user data.');
        setLoading(false);
      });
  }, [userId]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setUserData(prev => ({ ...prev, [name]: type === 'checkbox' ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    const payload = {
      fullName: userData.fullName,
      username: userData.username,
      email: userData.email,
      contactNo: userData.contactNo,
      address: userData.address,
      password: userData.password || undefined,
      roles: [{ id: roleIdMapping[userData.role] }],
      userCategory: { id: userData.userCategory },
      enabled: userData.enabled,
    };
    try {
      // Use the admin-specific endpoint that bypasses password validation
      await axios.put(`/api/users/${userId}/admin/update`, payload);
      setTooltip('User updated successfully.');
      setTimeout(() => navigate('/admin/users/view'), 2000);
    } catch (err) {
      setError('Error updating user.');
    }
  };

  if (loading) return <div className="container mt-4"><p>Loading user data...</p></div>;
  if (error) return <div className="container mt-4"><p className="text-danger">{error}</p></div>;

  return (
    <div className="container mt-2">
      <TitleWithBack title="Edit User" />
      <form onSubmit={handleSubmit} autoComplete="off">
        <div className="mb-3">
          <label className="form-label">Full Name:</label>
          <input type="text" name="fullName" className="form-control" value={userData.fullName} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Username:</label>
          <input type="text" name="username" className="form-control" value={userData.username} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Email:</label>
          <input type="email" name="email" className="form-control" value={userData.email} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Contact NO:</label>
          <input type="tel" name="contactNo" className="form-control" value={userData.contactNo} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Address Of Institution:</label>
          <input type="text" name="address" className="form-control" value={userData.address} onChange={handleChange} required />
        </div>
        <div className="mb-3">
          <label className="form-label">Password:</label>
          <input type="password" name="password" className="form-control" value={userData.password} onChange={handleChange} autoComplete="off" data-lpignore="true" data-1p-ignore="true" data-form-type="other" />
          <div className="form-text">Leave blank to keep current password.</div>
        </div>
        <div className="mb-3">
          <label className="form-label">Role:</label>
          <select name="role" className="form-select" value={userData.role} onChange={handleChange} required>
            <option value="">Select Role</option>
            <option value="admin">Admin</option>
            <option value="archiver">Archiver</option>
            <option value="examiner">Examiner</option>
            <option value="data team">Data Team</option>
            <option value="security">Security</option>
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">User Category:</label>
          <select name="userCategory" className="form-select" value={userData.userCategory} onChange={handleChange} required>
            <option value="">Select Category</option>
            {categories.map(cat => (
              <option key={cat.id} value={cat.id}>{cat.name}</option>
            ))}
          </select>
        </div>
        <div className="mb-3">
          <label className="form-label">Enable Or Disable Login :</label>
            <div className="form-check form-switch mt-1 ps-0">
          <input
            type="checkbox"
            name="enabled"
            checked={userData.enabled}
            onChange={handleChange}
          />
          <span className="ms-2">{userData.enabled ? 'Enabled' : 'Disabled'}</span>
          </div>
        </div>
        <button type="submit" className="btn btn-primary">Update User</button>
      </form>
      {tooltip && <div className="mt-3 alert alert-info">{tooltip}</div>}
    </div>
  );
}

export default UsersEdit;
